import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { PRIVACY_PATH, TERMS_PATH } from './legalLinks';
import { useMe } from './meContext';
import { ACCOUNT_PATHS, ACCOUNT_ROOT } from './paths';
import { arrivalFrom, type ReturnTo } from './returnTo';

/**
 * Logged in, but the sign-up questions aren't finished: to them first, then
 * back to the page the user was on (CONTRACT §7).
 *
 * Not on the account pages, which include the questions themselves and the
 * way to log out, nor on a shared schedule, which anyone may read, nor on the
 * terms and privacy pages, which the terms step itself opens in a new tab and
 * which would otherwise bounce back to it once `/me` answers. Only on a
 * definite answer from the API: while it is loading or unreachable the site
 * carries on as it does logged out, since the device still holds everything.
 */
export default function OnboardingGate() {
  const { status } = useMe();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (status.kind !== 'ready' || status.me.onboardingComplete) return;
    const { pathname } = location;
    if (pathname === ACCOUNT_ROOT || pathname.startsWith(`${ACCOUNT_ROOT}/`)) return;
    if (pathname.startsWith('/s/')) return;
    if (pathname === TERMS_PATH || pathname === PRIVACY_PATH) return;
    const returnTo: ReturnTo = { path: `${pathname}${location.search}`, arrival: arrivalFrom(location.state) };
    navigate(ACCOUNT_PATHS.welcome, { replace: true, state: { returnTo } });
  }, [status, location, navigate]);

  return null;
}
